import { renderElement } from "../../utils/use-render.js";
import { useMenuContext } from "./context.js";
import { completeMenuItemSelection } from "@videojs/core/dom";
import { forwardRef, useCallback, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/menu/item.tsx
/** A single action in the menu. Renders a `<div>` with `role="menuitem"`. */
const MenuItem = forwardRef(function MenuItem({ render, className, style, onSelect, disabled, onClick, ...elementProps }, forwardedRef) {
	const { menu, state } = useMenuContext();
	const elementRef = useRef(null);
	useEffect(() => {
		const element = elementRef.current;
		if (!element) return;
		return menu.registerItem(element);
	}, [menu]);
	const handleClick = useCallback((event) => {
		if (disabled) return;
		onClick?.(event);
		if (event.defaultPrevented) return;
		onSelect?.();
		completeMenuItemSelection(menu);
	}, [
		disabled,
		onClick,
		onSelect,
		menu
	]);
	const handlePointerEnter = useCallback(() => {
		const element = elementRef.current;
		if (!element || disabled) return;
		menu.highlight(element, {
			focus: false,
			pointer: true
		});
	}, [menu, disabled]);
	return /* @__PURE__ */ jsx(MenuItemContent, {
		disabled,
		elementProps,
		onClick: handleClick,
		onPointerEnter: handlePointerEnter,
		render,
		className,
		style,
		state,
		forwardedRef,
		elementRef
	});
});
function MenuItemContent({ disabled, elementProps, onClick, onPointerEnter, render, className, style, state, forwardedRef, elementRef }) {
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		ref: [forwardedRef, elementRef],
		props: [{
			role: "menuitem",
			"aria-disabled": disabled ? true : void 0,
			onClick,
			onPointerEnter
		}, elementProps]
	});
}
//#endregion
export { MenuItem };

//# sourceMappingURL=item.js.map